import React, { useEffect } from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { useValidatorSeeker } from "@app"
import { array, object } from "yup"
import { BACKEND_APIS } from "@constants"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData, autoEuropeDrawerErrors } from "Pages/AutoEuropeTool/Page/@signals"

export default function AutoEuropeReports() {
	const { dataInfo, setDataInfo } = useAutoEuropeDataInfo(autoEuropeDrawerData.peek().reports || [])

	const { errors, isValid } = useValidatorSeeker({ reports: dataInfo.value }, object({
		reports: array().min(1, "Must select at least one report")
	}))

	useEffect(() => {
		autoEuropeDrawerErrors.value = { ...autoEuropeDrawerErrors.value, reports: isValid }
	}, [JSON.stringify(errors)])

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false}
		multiple
		label="Reports"
		placeholder="Select reports"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/report/options/user-reports`}
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, "reports")}
		error={errors?.reports}
	/>
}
